import { format } from "date-fns";
import firebase from "firebase/app";

import { Divider, Modal } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import updateProduction from "astrid-firestore/src/api/productions/updateProduction";

import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";
import Button from "../../../../ui/components/Buttons/Button";
import ErrorMessage from "../../../../ui/components/Messages/ErrorMessage";

export default function ProductionOverviewDeliveryDateModal({ production, articles, onClose }) {
	const { t } = useTranslation();

	const { form, formState, onSubmit, error } = useSimpleForm({
		defaultValues: {
			deliveryDate: production.deliveryDate?.toDate() || null,
			...Object.fromEntries(
				articles.map((article) => [
					article.id,
					production.articles?.[article.id]?.deliveryDate?.toDate() || null,
				]),
			),
		},
		onSubmit: ({ deliveryDate, ...articleDeliveryDates }) => {
			const articlesMap = articles.reduce((acc, article) => {
				return {
					...acc,
					[article.id]: {
						deliveryDate: articleDeliveryDates[article.id] || null,
					},
				};
			}, {});

			return updateProduction(firebase, {
				ref: production.ref,
				deliveryDate,
				articles: articlesMap,
			});
		},
		onSuccess: onClose,
	});

	return (
		<Modal size="tiny" open onClose={onClose}>
			<Modal.Content>
				<Form form={form}>
					<Form.DateInput name="deliveryDate" label={t("deliveryDate", "Delivery date")} />

					{articles.length > 0 && (
						<>
							<Divider horizontal>
								<p>{t("addSpecificDeliveryDates", "Add specific delivery dates")}</p>
							</Divider>

							{articles.map((article) => (
								<Form.DateInput
									key={article.id}
									name={article.id}
									label={`${t("deliveryDate", "Delivery date")} (${article.isbn})`}
									placeholder={
										production?.deliveryDate &&
										format(production?.deliveryDate.toDate(), "yyyy-MM-dd")
									}
									rules={{ required: false }}
								/>
							))}
						</>
					)}
				</Form>

				{error && <ErrorMessage error={error} />}
			</Modal.Content>

			<Modal.Actions>
				<Button onClick={onClose}>{t("cancel", "Cancel")}</Button>

				<Button
					primary
					loading={formState.isSubmitting}
					disabled={formState.isSubmitting || !formState.isValid}
					onClick={onSubmit}
				>
					{t("save", "Save")}
				</Button>
			</Modal.Actions>
		</Modal>
	);
}
